import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { EmployeeInformationService } from 'src/app/data-analysis-summary/employee-information/employee-information.service';
import { SessionService } from '../../session-service/session.service';
import { Messages } from '../../constants/messages';
import { ToastrService } from '@kpmg-tax/ui';
@Component({
  selector: 'ei-delete-single-employee',
  templateUrl: './ei-delete-single-employee.component.html',
})
export class EiDeleteSingleEmployeeComponent implements OnInit {
  targetForm: FormGroup; // name of formGroup in template
  targetFormSubmitted: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public rightSideDrawerService: RightSideDrawerService,
    public sessionService: SessionService,
    private employeeInformationService: EmployeeInformationService,
    public toastrService: ToastrService,
  ) { }

  buildData(employee) {
    this.rightSideDrawerService.singleRowEditData = employee;
  }

  ngOnInit() {
    this.targetForm = this.formBuilder.group({
      engagementId: '',
      employeeId: '',
    });
  }

  deleteEmployee = () => {
    this.targetForm = this.formBuilder.group({
      engagementId: this.rightSideDrawerService.singleRowEditData.engagementId,
      employeeId: this.rightSideDrawerService.singleRowEditData.employeeId,
    });
    const empIds: number[] = [];
    empIds.push(this.rightSideDrawerService.singleRowEditData.employeeId);
    let deleteEmployeedata: { engagementId: number, employeeIds: number[] } = {
      engagementId: this.rightSideDrawerService.singleRowEditData.engagementId,
      employeeIds: empIds
    }
    this.employeeInformationService.deleteEmpRec(deleteEmployeedata).subscribe(data => {
      // If request is successful, Refresh data table on page
      this.employeeInformationService.refreshTable();
      this.rightSideDrawerService.closeRightSideDrawer();
      this.toastrService.setSuccessMessage(Messages.EMPLOYEE_DELETE_SUCCESS);
    });
  }
}
